import React from "react";
import TopBanner from "./TopBanner";
import Features from "./Features";

const Header = () => {
  return (
    <div>
      <TopBanner></TopBanner>
      {/* <Features></Features> */}
    </div>
  );
};

export default Header;
